import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <>
    {/* <Link to={`/categories/${item?.slug || item?.slugPath}`} className="custom-category-card text-decoration-none">
      <div className="category-image-container">
        <img
          src={item?.image}
          alt={item?.name}
          className="custom-category-image"
        />

        <div className="custom-category-overlay"></div>

        <div className="spotlight-layer"></div>
      </div>

      <div className="vertical-label">
        {item?.name}
      </div>

      <div className="custom-category-content p-3">
        <span className="custom-category-tag">
          LUXE DIRECTORY
        </span>

        <h3 className="custom-category-title mb-0">
          {item?.name}
        </h3>

        <Link
       to={`/categories/${item?.slug || item?.slugPath}`}
          className="custom-category-btn text-decoration-none"
        >
          Explore &rarr;
        </Link>
      </div>
    </Link> */}
    <Link
  to={`/categories/${item?.slug || item?.slugPath}`}
  className="custom-ax-pkh-cat-sec-card text-decoration-none"
>
  <div className="custom-ax-pkh-cat-sec-img-wrap">
    <img
      src={item?.image}
      alt={item?.name}
      className="custom-ax-pkh-cat-sec-img"
    />
  </div>

  <h3 className="custom-ax-pkh-cat-sec-title">
    {item?.name}
  </h3>
</Link>
    </>
  );
}

export default Card;